import React from 'react';
import ConstructionIcon from '@mui/icons-material/Construction';

function UnderConstruction() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
      <ConstructionIcon style={{ color: '#FF9C00', fontSize: '42px' }} />
      <h1 style={{ color: '#FF9C00', fontSize: '32px', fontWeight: 'bold' }}>UNDER CONSTRUCTION</h1>
      <ConstructionIcon style={{ color: '#FF9C00', fontSize: '42px' }} />
    </div>
  );
}

export default UnderConstruction;
